import IPresentation from '@app/types/presentations/presentation/IPresentation';
import IPresentationMaster from '@app/types/presentations/master/IPresentationMaster';

export default class PresentationMasterUtil {
	public static findPresentationMaster(
		presentation: IPresentation,
		mastersByIdAndLocale: Record<string, Record<string, IPresentationMaster>>
	): IPresentationMaster | undefined {
		return mastersByIdAndLocale[presentation.masterId] &&
			mastersByIdAndLocale[presentation.masterId][presentation.settings.locale]
			? mastersByIdAndLocale[presentation.masterId][presentation.settings.locale]
			: undefined;
	}

	public static findMasterSnapshotsByIdAndChecksum(
		masterId: string,
		checksum: string,
		masterSnapshotsByMasterIdChecksumAndLocale: Record<string, Record<string, Record<string, IPresentationMaster>>>
	): Record<string, IPresentationMaster> | undefined {
		if (
			!!masterSnapshotsByMasterIdChecksumAndLocale[masterId] &&
			!!masterSnapshotsByMasterIdChecksumAndLocale[masterId][checksum]
		) {
			return masterSnapshotsByMasterIdChecksumAndLocale[masterId][checksum];
		}

		return undefined;
	}

	public static findMasterSnapshotByIdChecksumAndLocale(
		presentation: IPresentation,
		masterSnapshotsByMasterIdChecksumAndLocale: Record<string, Record<string, Record<string, IPresentationMaster>>>
	): IPresentationMaster | undefined {
		if (
			!!masterSnapshotsByMasterIdChecksumAndLocale[presentation.masterId] &&
			!!masterSnapshotsByMasterIdChecksumAndLocale[presentation.masterId][presentation.masterChecksum] &&
			!!masterSnapshotsByMasterIdChecksumAndLocale[presentation.masterId][presentation.masterChecksum][
				presentation.settings.locale
			]
		) {
			return masterSnapshotsByMasterIdChecksumAndLocale[presentation.masterId][presentation.masterChecksum][
				presentation.settings.locale
			];
		}

		return undefined;
	}
}
